import { useState } from 'react';

import { CedulasPreview } from './CedulasPreview';
import { CedulasUpdate } from './CedulasUpdate';

import styles from '../Perfil.module.css';

export const Cedulas = ({ usuario }) => {

    const [cedulasUpdateStatus, setCedulasUpdateStatus] = useState(false);

    const handleEditarCedulas = () => {
        setCedulasUpdateStatus(true);
    }

    const handleCancelarEditarCedulas = () => {
        setCedulasUpdateStatus(false);
    }

    return (
        <>
            <div className={styles.subHeader}>Cédulas</div>
            {(!cedulasUpdateStatus)
            ? <CedulasPreview usuario={usuario} handleEditarCedulas={handleEditarCedulas} />
            : <CedulasUpdate usuario={usuario} handleCancelarEditarCedulas={handleCancelarEditarCedulas} />
            }
        </>
    )
}
